export const omitSensitiveAccountFields = (accountFields, { canViewSensitiveData = false } = {}) => {
  if (!Array.isArray(accountFields)) {
    return [];
  }
  if (canViewSensitiveData) {
    return accountFields;
  }
  return accountFields.filter((f) => f && !f.isSensitive);
};

export const isSensitiveFieldKey = (key, mappedFields) => {
  if (!key.startsWith('field-')) return false;
  const id = Number(key.split('-')[1]);
  return !!mappedFields?.[id]?.isSensitive;
};
